import { useQuery } from '@tanstack/react-query';
import { turnReportsGet2 } from '~/generated';
import { extractData } from '~/utils/query-utils';

type TurnReport = {
  attendees?: Array<{
    attendance?: string | null;
  }> | null;
  closed: boolean;
  id: number;
  turn: {
    id: number;
    turnAssignments: {
      publisherMiniRecord: {
        firstName: string;
        lastName: string;
      };
    }[];
  };
};

export const useTurnReport = (options: { id: number; expand?: string[] }) =>
  useQuery({
    queryFn: () =>
      extractData(
        turnReportsGet2({
          path: { id: options.id },
          query: { expand: options.expand },
          responseType: 'json',
        })
      ) as unknown as TurnReport,
    queryKey: ['turnReports', options.id, options.expand],
  });
